import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";
import { MatchMedia } from "../Lib/types";

const normalizeOptionalString = (value: unknown): string | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const str = String(value).trim();
  return str ? str : undefined;
};

const normalizeOptionalStringOrNull = (
  value: unknown
): string | null | undefined => {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  const str = String(value).trim();
  return str ? str : undefined;
};

const normalizeOid = (value: unknown): string | null | undefined => {
  const normalized = normalizeOptionalStringOrNull(value);
  if (normalized === null || normalized === undefined) {
    return normalized;
  }
  return normalized.replace(/^-/, "");
};

export const matchesMediaDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    update: async ({
      variables,
      meta,
    }: {
      id: number;
      resource: string;
      variables: MatchMedia;
      meta?: {
        fnlId?: number | string | null;
      };
    }) => {
      const updateUrl = "/cms/match/updateMedia";

      try {
        const payload: Record<string, unknown> = {
          ...variables,
        };

        if (payload.type === "ANNOUNCE_CONF") {
          delete payload.url;
        }

        const url = normalizeOptionalStringOrNull(payload.url);
        if (url === undefined) delete payload.url;
        else payload.url = url;

        const videoUrl = normalizeOptionalStringOrNull(payload.videoUrl);
        if (videoUrl === undefined) delete payload.videoUrl;
        else payload.videoUrl = videoUrl;

        const vidOid = normalizeOid(payload.vidOid);
        if (vidOid === undefined) delete payload.vidOid;
        else payload.vidOid = vidOid;

        const vidId = normalizeOptionalStringOrNull(payload.vidId);
        if (vidId === undefined) delete payload.vidId;
        else payload.vidId = vidId;

        const typeLink = normalizeOptionalString(payload.typeLink);
        if (typeLink) payload.typeLink = typeLink;
        else delete payload.typeLink;

        const normalizedGameFnlId = normalizeOptionalString(payload.gameFnlId);
        const fallbackGameFnlId = normalizeOptionalString(meta?.fnlId);
        const gameFnlId = normalizedGameFnlId ?? fallbackGameFnlId;

        if (gameFnlId === undefined) delete payload.gameFnlId;
        else payload.gameFnlId = gameFnlId;

        const { data } = await httpClient.post(updateUrl, {
          ...payload,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({
      resource,
      variables,
      meta,
    }: {
      resource: string;
      variables: MatchMedia;
      meta: {
        matchId: number;
        leagueId: number;
        fnlId?: number | string | null;
        type?: string;
      };
    }) => {
      const updateUrl = "/cms/match/addMedia";

      const { matchId, leagueId, fnlId, type: metaType } = meta;
      const mediaType = variables.type || metaType;

      try {
        const payload: Record<string, unknown> = {
          ...variables,
          matchId,
          leagueId,
          ...(mediaType ? { type: mediaType } : {}),
        };

        if (payload.type === "ANNOUNCE_CONF") {
          delete payload.url;
        }

        const url = normalizeOptionalStringOrNull(payload.url);
        if (url === undefined) delete payload.url;
        else payload.url = url;

        const videoUrl = normalizeOptionalStringOrNull(payload.videoUrl);
        if (videoUrl === undefined) delete payload.videoUrl;
        else payload.videoUrl = videoUrl;

        const vidOid = normalizeOid(payload.vidOid);
        if (vidOid === undefined) delete payload.vidOid;
        else payload.vidOid = vidOid;

        const vidId = normalizeOptionalStringOrNull(payload.vidId);
        if (vidId === undefined) delete payload.vidId;
        else payload.vidId = vidId;

        const typeLink = normalizeOptionalString(payload.typeLink);
        if (typeLink) payload.typeLink = typeLink;
        else delete payload.typeLink;

        const normalizedGameFnlId = normalizeOptionalString(payload.gameFnlId);
        const fallbackGameFnlId = normalizeOptionalString(fnlId);
        const gameFnlId = normalizedGameFnlId ?? fallbackGameFnlId;

        if (gameFnlId === undefined) delete payload.gameFnlId;
        else payload.gameFnlId = gameFnlId;

        const { data } = await httpClient.post(updateUrl, {
          ...payload,
          // url: variables.url || "",
          // photos: variables.photos || [],
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ resource, id, meta }) => {
      const url = "/cms/match/removeMedia";

      try {
        const { data } = await httpClient.post(
          `${url}?${qs.stringify({ mediaId: id })}`
        );
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
